import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1de07886"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lightbox"
}
const _hoisted_2 = {
  key: 1,
  class: "lightbox"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "lightbox__loading-icon",
  viewBox: "0 0 50 50"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "path",
  cx: "25",
  cy: "25",
  r: "20",
  fill: "none",
  "stroke-width": "5"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignageLayoutPreview = _resolveComponent("SignageLayoutPreview")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "lightbox" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args)))
            }, [
              (_ctx.signageLayout)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_SignageLayoutPreview, {
                      class: "lightbox__preview",
                      style: {"zoom":"0.7"},
                      signageLayout: _ctx.signageLayout,
                      showEdit: false
                    }, null, 8, ["signageLayout"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("img", {
                      class: "lightbox__image",
                      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args))),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($event.stopPropagation())),
                      src: _ctx.image
                    }, null, 40, _hoisted_3), [
                      [_vShow, _ctx.isImageLoaded]
                    ]),
                    (!_ctx.isImageLoaded)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}